(function($) {
    $.widget("ca.caMultiSelectionList", {
        options: {
            changeable: true,
            selectAllMode: false,
            isTabbedLabel: false,
            tabItems: null,
            tabControl: null,
            singleTabKey: null,
            singleTabName: null
        },

        _create : function() {
            var self = this;
            var selectedRow = $(this.element).find(':checked');
            selectedRow.parent().addClass('selected');

            this.setChangeable(this.options.changeable);

            if (this.options.isTabbedLabel) {
                this.options.tabControl = $(this.element).parent().parent().find('.ca-selection-list-title');
                var tabs = this.options.tabControl.find('.ca-selection-list-tab');
                tabs.on('click', function() {
                    self.onLabelTabClick(this);
                });

                tabs.first().click();
            }
        },

        setChangeable: function(changeable) {
            var self = this;
            this.options.changeable = !!changeable;
            if (changeable) {
                this.element.find('label').off('click.selectionlist').on('click.selectionlist', function() {
                    if ($(this).hasClass('disabled')) {
                        return false;
                    }
                    var allElement = $(this).parent().find('label:first-child');
                    var input = $(this).find('input');
                    var isAll = input.val() === 'all';

                    var tabId = null;
                    if (self.options.tabItems && self.options.tabControl) {
                        tabId = self.options.tabControl.find('.ca-selection-list-active-tab').data('tabId');
                    }

                    if ($(this).hasClass('selected')) {
                        $(this).removeClass('selected');
                        input.prop("checked", false);

                        if (self.options.selectAllMode) {
                            self.setAllChecked(0, tabId);
                            if (isAll) {
                                if (tabId) {
                                    $(this).parent().find('label.selected').each(function() {
                                        var id = $(this).find('input').val();
                                        if (typeof self.options.tabItems[id] !== 'undefined'
                                            && self.options.tabItems[id] == tabId
                                        ) {
                                            $(this).closest('label').trigger('click');
                                        }
                                    });
                                } else {
                                    $(this).parent().find('label.selected').trigger('click');
                                }
                            } else {
                                allElement.removeClass('selected');
                                allElement.find('input').prop("checked", false);
                            }
                        }
                    } else {
                        $(this).addClass('selected');
                        input.prop("checked", true);

                        if (self.options.selectAllMode) {
                            if (isAll) {
                                self.setAllChecked(1, tabId);
                                if (tabId) {
                                    $(this).parent().find('label:not(.selected)').each(function() {
                                        var id = $(this).find('input').val();
                                        if (typeof self.options.tabItems[id] !== 'undefined'
                                            && self.options.tabItems[id] == tabId
                                        ) {
                                            $(this).closest('label').trigger('click');
                                        }
                                    });
                                } else {
                                    $(this).parent().find('label:not(.selected)').trigger('click');
                                }
                            } else if (tabId) {
                                var count = 0;
                                $(this).parent().find('label:not(.selected)').each(function() {
                                    var id = $(this).find('input').val();
                                    if (typeof self.options.tabItems[id] !== 'undefined'
                                        && self.options.tabItems[id] == tabId
                                    ) {
                                        count++;
                                    }
                                });

                                if (count === 0) {
                                    allElement.addClass('selected');
                                    allElement.find('input').prop("checked", true);
                                    self.setAllChecked(1, tabId);
                                }
                            } else if ($(this).parent().find('label:not(.selected)').length === 1) {
                                allElement.addClass('selected');
                                allElement.find('input').prop("checked", true);
                                self.setAllChecked(1, tabId);
                            }
                        }
                    }

                    self._trigger('change');

                    return false;
                }).removeClass('disabled');
            } else {
                this.element.find('label').off('click.selectionlist').on('click.selectionlist', function() {
                    return false;
                }).addClass('disabled');
            }
        },

        setAllChecked: function(isChecked, tabId) {
            var self = this;
            var allInput = null;
            if (tabId) {
                allInput = $("#" + $(this).parent().attr('id') + "-select-all-" + tabId);
            } else if (self.options.singleTabKey && self.options.singleTabName) {
                allInput = $("#" + self.options.singleTabName + "-select-all-" + self.options.singleTabKey);
            }

            if (allInput && allInput.length > 0) {
                allInput.val(isChecked);
            }
        },

        onLabelTabClick: function(element) {
            var self = this;
            $(element).closest('.ca-selection-list-title').find('.ca-selection-list-tab').removeClass('ca-selection-list-active-tab');
            $(element).addClass('ca-selection-list-active-tab');

            var tabId = $(element).data('tabId');

            $(this.element).find('input').each(function() {
                var id = $(this).val();
                if (self.options.tabItems[id] != undefined && tabId) {
                    if (self.options.tabItems[id] != tabId) {
                        $(this).closest('label').hide();
                    } else {
                        $(this).closest('label').show();
                    }
                }
            });

            if (self.options.selectAllMode) {
                var options = $(this.element).find('label').not(':first-child').not('.selected').filter(function(){ return $(this).css('display') != 'none';});

                var allElement = $(this.element).find('label:first-child');
                if (options.length > 0) {
                    allElement.removeClass('selected');
                    allElement.find('input').removeAttr('checked');
                } else {
                    input_id = $(this.element).attr('id');
                    if (($("#"+input_id+"-select-all-"+tabId).length > 0)){
                        $("#"+input_id+"-select-all-"+tabId).val(1);
                    }
                    allElement.addClass('selected');
                    allElement.find('input').attr('checked', 'checked');
                }
            }
        },

        checkItem: function(itemId) {
            var itemId = $(this.element).prop('id') + '-' + itemId;

            $(this.element).find('#' + itemId).prop('checked', true).parent().addClass('selected');

            this._trigger('change');
        },

        uncheckItem: function(itemId) {
            var itemId = $(this.element).prop('id') + '-' + itemId;

            $(this.element).find('#' + itemId).prop('checked', false).parent().removeClass('selected');

            this._trigger('change');
        },

        uncheckAll: function(skipTrigger) {
            $(this.element).find(':checked').each(function() {
                $(this).attr('checked', false).parent().removeClass('selected');
            });

            if (skipTrigger != true) {
                this._trigger('change');
            }
        }
    });
})(jQuery);
